<template>
  <div>
    <a v-if="ebayUrl" :href="ebayUrl" class="btn btn-primary">
      <i class="bi bi-arrow-left-right me-1"></i> {{ eBayStatus?.connected === 'PAUSED' ? 'Reconnect' : 'Connect' }} eBay Store
    </a>
  </div>
</template>

<script setup>

import { ref, computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const ebayUrl = ref(null)
const eBayStatus = computed(() => store.state.eBayStatus)

store.dispatch('eshop/getEbayAuthUrl')
    .then(url => {
      console.log('authUrl', url)
      ebayUrl.value = url
    })
    .catch(e => console.error('get ebay authurl error', e))

</script>
